import React from 'react';
import { Instagram, Facebook, MapPin, Mail, Phone } from 'lucide-react';
import { Link } from 'react-router-dom';
export const Footer = () => {
  return <footer className="bg-brand-darker pt-16 md:pt-24 pb-8 md:pb-12 border-t border-brand-border/30 relative overflow-hidden" data-id="element-50">
      {/* Texture Overlay */}
      <div className="absolute inset-0 z-[1] opacity-25 pointer-events-none" style={{
      backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/dVpaC3masLzjuXAtkFBcMi/ChatGPT_Image_22._apr._2026,_23_19_05.webp)',
      backgroundSize: 'cover',
      backgroundPosition: 'center'
    }} data-id="element-51" />

      <div className="max-w-[1400px] mx-auto px-6 md:px-12 relative z-10" data-id="element-52">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-16 mb-16 md:mb-20" data-id="element-53">
          {/* Brand */}
          <div className="sm:col-span-2 lg:col-span-1" data-id="element-54">
            <div className="mb-6" data-id="element-55">
              <img src="https://cdn.magicpatterns.com/uploads/8UGBnXPL8tFE9Y31LhhwcB/Dispel_Blanc.svg" alt="Dispel Your Tattoo" className="h-12 md:h-14 w-auto" data-id="element-56" />
            </div>
            <p className="text-brand-gray font-light text-sm leading-relaxed max-w-xs" data-id="element-57">
              Studio spécialisé en détatouage laser à Martigny. Technologie
              picoseconde & nanoseconde pour des résultats sûrs et efficaces.
            </p>
          </div>

          {/* Navigation */}
          <nav aria-label="Navigation du pied de page" data-id="element-58">
            <p className="text-brand-light font-bold uppercase tracking-widest text-sm mb-6" data-id="element-59">
              Navigation
            </p>
            <ul className="space-y-3 md:space-y-4 text-sm text-brand-gray font-light" data-id="element-60">
              <li data-id="element-61">
                <Link to="/technologie-laser" className="hover:text-brand-light transition-colors block py-1 md:py-0" data-id="element-62">
                  Technologie laser
                </Link>
              </li>
              <li data-id="element-63">
                <Link to="/avant-apres" className="hover:text-brand-light transition-colors block py-1 md:py-0" data-id="element-64">
                  Avant / Après
                </Link>
              </li>
              <li data-id="element-65">
                <Link to="/tarifs" className="hover:text-brand-light transition-colors block py-1 md:py-0" data-id="element-66">
                  Tarifs
                </Link>
              </li>
              <li data-id="element-67">
                <Link to="/faq" className="hover:text-brand-light transition-colors block py-1 md:py-0" data-id="element-68">
                  FAQ
                </Link>
              </li>
              <li data-id="element-69">
                <Link to="/blog" className="hover:text-brand-light transition-colors block py-1 md:py-0" data-id="element-70">
                  Blog
                </Link>
              </li>
              <li data-id="element-71">
                <Link to="/contact" className="hover:text-brand-light transition-colors block py-1 md:py-0" data-id="element-72">
                  Contact
                </Link>
              </li>
            </ul>
          </nav>

          {/* Contact */}
          <div data-id="element-73">
            <p className="text-brand-light font-bold uppercase tracking-widest text-sm mb-6" data-id="element-74">
              Contact
            </p>
            <ul className="space-y-4 text-sm text-brand-gray font-light" data-id="element-75">
              <li className="flex items-start space-x-3" data-id="element-76">
                <MapPin size={18} className="shrink-0 mt-0.5 text-brand-light/50" data-id="element-77" />
                <a href="https://share.google/HfzVyKv5w71opN00D" target="_blank" rel="noopener noreferrer" className="hover:text-brand-light transition-colors" data-id="element-78">
                  Rue de la Délèze 2
                  <br data-id="element-79" />
                  1920 Martigny
                </a>
              </li>
              <li className="flex items-center space-x-3" data-id="element-80">
                <Mail size={18} className="shrink-0 text-brand-light/50" data-id="element-81" />
                <a href="mailto:dispeltattoo@gmail.com" className="hover:text-brand-light transition-colors break-all" data-id="element-82">
                  dispeltattoo@gmail.com
                </a>
              </li>
              <li className="flex items-center space-x-3" data-id="element-83">
                <Phone size={18} className="shrink-0 text-brand-light/50" data-id="element-84" />
                <a href="tel:+41791026945" className="hover:text-brand-light transition-colors" data-id="element-85">
                  079 102 69 45
                </a>
              </li>
            </ul>
          </div>

          {/* Social */}
          <div data-id="element-86">
            <p className="text-brand-light font-bold uppercase tracking-widest text-sm mb-6" data-id="element-87">
              Réseaux
            </p>
            <div className="flex space-x-4" data-id="element-88">
              <a href="https://www.instagram.com/dispel_your_tattoo/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full border border-brand-border flex items-center justify-center text-brand-gray hover:text-brand-light hover:border-brand-light transition-all duration-300" data-id="element-89">
                <Instagram size={18} data-id="element-90" />
              </a>
              <a href="https://www.facebook.com/dispelyourtattoo" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full border border-brand-border flex items-center justify-center text-brand-gray hover:text-brand-light hover:border-brand-light transition-all duration-300" data-id="element-91">
                <Facebook size={18} data-id="element-92" />
              </a>
              <a href="https://www.tiktok.com/@dispel_your_tattoo" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full border border-brand-border flex items-center justify-center text-brand-gray hover:text-brand-light hover:border-brand-light transition-all duration-300 font-bold italic text-sm" data-id="element-93">
                Tk
              </a>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="pt-8 border-t border-brand-border/30 flex flex-col md:flex-row items-center justify-between text-xs text-brand-gray/60 font-light text-center md:text-left gap-4 md:gap-0" data-id="element-94">
          <p data-id="element-95">
            &copy; {new Date().getFullYear()} Dispel Your Tattoo. Tous droits
            réservés.
          </p>
          <div className="flex flex-wrap justify-center gap-4 md:space-x-6" data-id="element-96">
            <Link to="/mentions-legales" className="hover:text-brand-gray transition-colors" data-id="element-97">
              Mentions légales
            </Link>
            <Link to="/politique-de-confidentialite" className="hover:text-brand-gray transition-colors" data-id="element-98">
              Politique de confidentialité
            </Link>
          </div>
        </div>
      </div>
    </footer>;
};